export default __webpack_public_path__ + "static/postgresql-6801a5d0da6745842dc2b4006c5123f8.png";